<template>
  <div class="virtual-account-container" @click.stop>
    <div class="current-type-container" @click="showPaymentSelecter = true">
      <span class="type-category">
        {{ changePriceFormat(curPrice) }} {{ curPayType.show_currency }}
        <span class="get-text" style="margin: 0 5px">=</span>
        {{ getProductName(curProduct) }}
        <template v-if="+curProduct.PRODUCT_EXTRA_COIN">
          + {{ curProduct.PRODUCT_EXTRA_COIN }}
          {{ coinName }}
        </template>
        <template v-if="+curPrice.SUB_COIN">
          + {{ curPrice.SUB_COIN }}{{ subCoinNama }}
        </template>
        <template v-if="+curPrice.EXTRA_COIN">
          + {{ curPrice.EXTRA_COIN }} {{ extraCoinName }}
        </template>
      </span>
      <Icon class="selected-type-icon" name="down"></Icon>
    </div>
    <PaymentSelecter
      v-if="showPaymentSelecter"
      @closeSelecter="showPaymentSelecter = false"
      :curPayType="curPayType"
      :curProduct="curProduct"
      :curPrice="curPrice"
      :pricesList="pricesList"
      v-bind:showChildSelector="showPaymentSelecter"
      @selectPayMent="selectPayMent"
    ></PaymentSelecter>
  </div>
</template>

<script>
import PaymentSelecter from '@components/officialTopupNew/paytype/PaymentSelecter';
import { changePriceFormat } from '@utiles/officialStore';
import { mapGetters } from 'vuex';
import product from '@mixins/product';
export default {
  name: 'Payment',
  mixins: [product],
  props: {
    curPayType: {
      require: true
    },
    languages: {
      require: true
    },
    curProduct: {
      require: true
    },
    pricesList: {
      require: true
    },
    curPrice: {
      require: true
    }
  },
  data() {
    return {
      showPaymentSelecter: false,
      originCoin: 0,
      extraCoin: 0,
      totalCoin: 0
    };
  },
  computed: {
    coinName() {
      return this.$store.state.coinName;
    },
    ...mapGetters(['subCoinNama', 'extraCoinName'])
  },
  watch: {
    curPrice: {
      deep: true,
      immediate: true,
      handler(newVal) {
        this.originCoin = +(newVal?.COIN || 0);
        this.extraCoin = +(newVal?.EXTRA_COIN || 0);
        this.totalCoin = this.originCoin + this.extraCoin;
      }
    }
  },
  methods: {
    changePriceFormat(price) {
      if (price !== undefined) {
        return changePriceFormat(price?.CURRENCY, price?.TRANS_AMOUNT);
      }
      return price && price?.TRANS_AMOUNT;
    },
    selectPrice(price) {
      this.curPrice = price;
      this.$nextTick(() => {
        this.showPaymentSelecter = false;
      });
    },
    selectPayMent(payment) {
      this.$emit('selectPayMent', payment);
      this.showPaymentSelecter = false;
    }
  },
  components: {
    PaymentSelecter
  }
};
</script>

<style scoped lang="scss">
.ico {
  width: 25px;
  margin: 0px 5px;
}
.type-category {
  display: flex;
  align-items: center;
}
</style>
